/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { satisfies } from 'semver';
import { normalizeVersion } from 'libs/utils/packages';
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import SecretsInput from 'shared/ui/components/form-components/SecretsInput.vue';
import MappedFields from 'shared/ui/components/MappedFields.vue';

const __vue_script__ = {
    name: 'LeadsEnrichmentIntegration',

    components: {
        BaseInput,
        BaseSelect,
        SecretsInput,
        MappedFields,
    },

    props: {
        eid: {
            type: String,
            required: true,
        },
        availableIntegrations: {
            type: Array,
            required: true
        },
        integrationConfig: {
            type: Object,
            default: () => ({}),
        },
        integrationIndex: {
            type: Number,
            required: true,
        },

        prospectMetadata: {
            type: Object,
            required: true
        },

        value: {
            type: Object,
            default: () => ({}),
        },

        apiFields: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            innerValue: {},
            currentIntegration: {},
            integrationOptions: [],
            showExtraFields: false
        };
    },

    computed: {
        mappedFieldsProvider() {
            const name = this.integrationConfig?.name || this.value?.name || '';
            return name.toLowerCase();
        },

        mappableApiFields() {
            return this.apiFields[this.mappedFieldsProvider]?.fields || [];
        },

        searchableApiFields() {
            return this.apiFields[this.mappedFieldsProvider]?.searchable || [];
        },

        searchFieldOptions() {
            const map = this.innerValue?.integration_fields_map || {};
            const metadataFields = new Set(Object.entries(map)
                .filter(([apiField, mdField]) => mdField && this.searchableApiFields.includes(apiField))
                .map(([, mdField]) => mdField)
            );
            return Object.values(this.prospectMetadata)
                .filter(field => metadataFields.has(field.name))
                .map(field => ({ value: field.name, label: field.label }));
        },

        fieldOptions() {
            const map = this.innerValue?.integration_fields_map || {};
            const metadataFields = Object.values(map);
            return metadataFields.map(field => ({ value: field, label: this.prospectMetadata[field]?.label || field }));
        }
    },

    watch: {
        innerValue: {
            deep: true,
            handler(value) {
                this.$emit('change', { ...value });
            }
        },

        searchFieldOptions() {
            if (!this.innerValue.search_fields?.length) {
                this.innerValue.search_fields = this.searchFieldOptions.map(o => o.value);
            }
        }
    },

    async created() {
        this.currentIntegration = { key: this.value._id, label: this.value.name };
        this.innerValue = {
            search_fields: [],
            ...this.value
        };
        this.updateIntegrationOptions();

        try {
            const packages = await this.$services.market.getInstalledPackages(this.eid);
            if (packages?.leads) {
                const leadsPkgVersion = normalizeVersion(packages.leads);
                this.showExtraFields = satisfies(leadsPkgVersion, '>=3.13.0');
            }
        } catch (err) {
            console.error('Failed to fetch installed packages', err);
        }
    },

    methods: {
        updateIntegrationOptions() {
            this.integrationOptions = [{ key: this.value._id, label: this.value.name }];
            for (const { _id, name } of this.availableIntegrations) {
                this.integrationOptions.push({ key: _id, label: name });
            }
        },

        onIdChange(e) {
            if (e.key) {
                this.$emit('id-change', {
                    from: { _id: this.value._id, name: this.value.name },
                    to: { _id: e.key, name: e.label },
                });
            }
        },

        async onMappedFieldsSaved() {
            this.$emit('save-settings');
        },
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "leads-enrichment-integration" },
    [
      _c("h4", [
        _c("span", [
          _vm._v(
            _vm._s("#" + (_vm.integrationIndex + 1)) +
              " " +
              _vm._s(_vm.$t("leads.settings.integration"))
          ),
        ]),
        _c(
          "a",
          {
            staticClass: "btn btn-mini has-action",
            attrs: { href: "#" },
            on: {
              click: function ($event) {
                return _vm.$emit("delete", _vm.value._id)
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("leads.settings.delete_integration")))]
        ),
      ]),
      _c("validation-provider", {
        attrs: { slim: true, name: "intergration_name" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var errors = ref.errors
              return [
                _c("base-select", {
                  attrs: {
                    name: "intergration_name",
                    label: _vm.$t("leads.settings.integration_name"),
                    options: _vm.integrationOptions,
                    "allow-empty": false,
                  },
                  on: { input: _vm.onIdChange },
                  model: {
                    value: _vm.currentIntegration,
                    callback: function ($$v) {
                      _vm.currentIntegration = $$v
                    },
                    expression: "currentIntegration",
                  },
                }),
              ]
            },
          },
        ]),
      }),
      _c("validation-provider", {
        attrs: { slim: true, name: "url" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var errors = ref.errors
              return [
                _c("base-input", {
                  attrs: {
                    type: "url",
                    name: "url",
                    label: _vm.$t("leads.settings.integration_url"),
                    required: true,
                    "avoid-password-managers": true,
                  },
                  model: {
                    value: _vm.innerValue.url,
                    callback: function ($$v) {
                      _vm.$set(_vm.innerValue, "url", $$v)
                    },
                    expression: "innerValue.url",
                  },
                }),
              ]
            },
          },
        ]),
      }),
      _c("validation-provider", {
        attrs: { slim: true, name: "secret_key" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var errors = ref.errors
              return [
                _c("secrets-input", {
                  attrs: {
                    name: "secret_key",
                    label: _vm.$t("leads.settings.integration_secret_key"),
                    required: true,
                  },
                  model: {
                    value: _vm.innerValue.secret_key,
                    callback: function ($$v) {
                      _vm.$set(_vm.innerValue, "secret_key", $$v)
                    },
                    expression: "innerValue.secret_key",
                  },
                }),
              ]
            },
          },
        ]),
      }),
      _vm.mappableApiFields.length && _vm.showExtraFields
        ? _c("mapped-fields", {
            attrs: {
              label: _vm.$t("integrations.fields_mapping"),
              provider: _vm.mappedFieldsProvider,
              "api-fields": _vm.mappableApiFields,
              "entity-type": "prospect",
              eid: _vm.eid,
            },
            on: { saved: _vm.onMappedFieldsSaved },
            model: {
              value: _vm.innerValue.integration_fields_map,
              callback: function ($$v) {
                _vm.$set(_vm.innerValue, "integration_fields_map", $$v)
              },
              expression: "innerValue.integration_fields_map",
            },
          })
        : _vm._e(),
      _vm.showExtraFields
        ? _c("base-select", {
            attrs: {
              name: "search_fields",
              label: _vm.$t("leads.settings.integration_search_fields"),
              tip: _vm.$t("leads.settings.integration_search_fields_hint"),
              "track-by": "value",
              taggable: true,
              multiple: true,
              options: _vm.searchFieldOptions,
              emitOptionValueOnly: true,
            },
            model: {
              value: _vm.innerValue.search_fields,
              callback: function ($$v) {
                _vm.$set(_vm.innerValue, "search_fields", $$v)
              },
              expression: "innerValue.search_fields",
            },
          })
        : _vm._e(),
      _c("base-select", {
        attrs: {
          name: "fields_to_populate",
          label: _vm.$t("leads.settings.integration_fields_to_populate"),
          "track-by": "value",
          taggable: true,
          "hint-after-label": true,
          multiple: true,
          options: _vm.fieldOptions,
          emitOptionValueOnly: true,
        },
        model: {
          value: _vm.innerValue.fields_to_populate,
          callback: function ($$v) {
            _vm.$set(_vm.innerValue, "fields_to_populate", $$v)
          },
          expression: "innerValue.fields_to_populate",
        },
      }),
      _c("hr"),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/leads/LeadsEnrichmentIntegration.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__